<template>
  <div>
    <div class="bg-no-repeat bg-cover h-auto mb-10">
      <div class="w-full relative">
        <img src="@/assets/images/home/产品首页图片.png" />
        <div
          class="absolute top-0 bottom-0 grid grid-cols-6 gap-4 h-full flex flex-wrap content-center text-white text-3xl"
        >
          <div class="col-start-4 col-span-4">产品</div>
        </div>
      </div>
    </div>

    <div
      class="mx-auto mb-2 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg hover:bg-gray-100"
      v-for="(item, index) in items"
      :key="index"
      @click="$router.push(item.link)"
    >
      <div class="flex items-center">
        <div class="flex-no-grow px-4 my-4 border-r border-gray-500">
          <img class="w-5" :src="`${item.icon}`" />
        </div>
        <div class="flex-grow px-4 my-4  text-lg">
          {{ item.title }}
        </div>
        <div class="flex-no-grow px-4 my-4">
          <svg
            class="text-gray-400 w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "hello",
  data() {
    return {
      items: [
        {
          icon: require("@/assets/images/home/胶枪,胶桶,混合管图标.png"),
          title: "胶枪",
          link: "/products/glue",
        },
        {
          icon: require("@/assets/images/home/胶桶混合管图标.png"),
          title: "胶筒/混合管",
          link: "/products/industry",
        },
        {
          icon: require("@/assets/images/home/应用图标.png"),
          title: "应用",
          link: "/products/construction",
        },
      ],
    };
  },
};
</script>
<style scoped></style>
